import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";
import { getFeatureFlags } from "@/lib/api";

export function useOnchainPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];
  const flags = getFeatureFlags();

  return {
    featureEnabled: flags.onchainProofs,
    canManage: flags.onchainProofs && roleHasPermission(role, "company:onchain"),
    role,
  };
}
